import type { SxProps, Theme } from "@mui/material/styles";

import type { StatusBadgeColor, StatusBadgeSize } from "./StatusBadge.types";

const colorMap: Record<StatusBadgeColor, (theme: Theme) => string> = {
  error: (theme) => theme.palette.error.main,
  warning: (theme) => theme.palette.warning.main,
  info: (theme) => theme.palette.info.main,
  success: (theme) => theme.palette.success.main,
  neutral: (theme) => theme.palette.text.secondary,
};

export const root =
  (color: StatusBadgeColor, size: StatusBadgeSize): SxProps<Theme> =>
  (theme) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colorMap[color](theme),
    color: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    fontWeight: 700,
    whiteSpace: "nowrap",
    px: size === "sm" ? 1.5 : 2,
    py: size === "sm" ? 0.25 : 0.75,
    fontSize: size === "sm" ? "0.6875rem" : "1rem",
    lineHeight: 1.4,
  });
